import React, { createContext, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../store/slices/authSlice';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { user, isAuthenticated, tokens } = useSelector((state) => state.auth);

  useEffect(() => {
    // Check if user has valid tokens on app load
    const accessToken = localStorage.getItem('access_token');
    if (accessToken && !user) {
      // Silently fetch profile, don't show errors
      dispatch(getProfile()).catch(() => {
        // Ignore profile fetch errors on initial load
      });
    }
  }, [dispatch, user]);

  const value = {
    user,
    isAuthenticated,
    tokens,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
